import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import environment from "./AuthEnv";
import { ITEMS_PER_PAGE } from "./constants";
import { ROOT_ID } from "relay-runtime";
import AnalysePageContainer from "./AnalysePageContainer";
import Spinner from "./Spinner";

const childFeedsQuery = graphql`
    query AnalysePageContainerWrapperQuery($parent: ID) {
        subscriptions(parent: $parent) {
            ...AnalysePageContainer_child_Subs
        }
    }
`;

// const { selectedSourceId } = environment.getStore().getSource().get(ROOT_ID);
// console.log("SelectedSourceId: " + selectedSourceId);

function AnalysePageContainerWrapper(props) {
    const { selectedParentId } = props.settings;
    const settings = props.settings;
    const user = props.user;
    const { is_premium, payment_status } = props.user;

    let isPremiumOrTrialing = false;

    if (payment_status === "active" || payment_status === "trialing") {
        isPremiumOrTrialing = true;
    } else if (payment_status === "past_due") {
        // navigate("/complete-payment");
    } else {
        // navigate("/upgrade");
    }

    return (
        <QueryRenderer
            environment={environment}
            query={childFeedsQuery}
            variables={{
                parent: selectedParentId,
            }}
            render={({ error, props }) => {
                if (error) {
                    return <div>Error!</div>;
                }
                if (!props) {
                    return <div><Spinner loading={true} /></div>;
                }
                return (
                    <>
                        {isPremiumOrTrialing ? (
                            <AnalysePageContainer
                                user={user}
                                settings={settings}
                                child_Subs={props.subscriptions}
                            />
                        ) : null}
                    </>
                );
            }}
        />
    );
}

export default AnalysePageContainerWrapper;
